import makeValidationSchema from './PersonDTOMakeValidationSchema'
import { components, constants, useTranslation } from 'cng-web-lib'
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Namespace from 'src/constants/locale/Namespace'
import ManifestKeys from 'src/constants/locale/key/AciHighwayManifest'
import CrewMasterApiUrls from "../../../apiUrls/CrewMasterApiUrls"
import { Box, Divider, Grid, IconButton, InputAdornment, Typography, useTheme } from '@material-ui/core'
import { useFormContext, useWatch } from "react-hook-form";
import moment from 'moment-timezone'
import Switch from 'src/components/Switch'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TemplateSelectDialog from '../../../components/aciacehighway/TemplateSelectDialog'
import PersonDocumentSection from './PersonDocumentSection'
import CngSection from 'src/components/cngcomponents/CngSection'
import TinyChip from '../../../components/aciacehighway/TinyChip'
import PersonDocumentDTOFormProperties from './PersonDocumentDTOFormProperties'
import { NaCrewMasterAutoCompleteField } from 'src/components/na/autocomplete/codemaintenance'
import { FileForUserGetPartyId } from 'src/common/FileForUserCommon'
import { AciAceCrewTypeMapping } from 'src/common/AciAceCrossMapping'
import * as InputSource from 'src/common/InputSource'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngButton },
  form: {
    field: {
      CngCheckboxField,
      CngTextField,
      CngDateField,
      CngCodeMasterAutocompleteField,
      CngCountryAutocompleteField
    },
  },
  CngGridItem,
} = components

const {
  filter: { LIKE, EQUAL }
} = constants

const DEFAULT_INITIAL_VALUES = Object.freeze({
  crewId: "",
  role: "",
  fastCard: false,
  saveCrewFlag: false,
  fetchCrew: "",
  fastCardNum: "",
  firstName: "",
  middleName: "",
  lastName: "",
  citizenShip: "",
  dateOfBirth: "",
  personEmail: "",
  cellNum: "",
  personDocumentDTO: []
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  // makeValidationSchema: makeValidationSchema
}


function Fields({
  disabled,
  showNotification,
  parentIdDropdownItems,
  shouldHideMap,
  index
}) {
  const { getValues, setValue, reset, trigger, watch } = useFormContext();
  const { translate } = useTranslation(Namespace.ACIHWY_MANIFEST)
  const [templateDialog, setTemplateDialog] = useState(false)
  const theme = useTheme()
  const { _id: _personDTOId } = useWatch()

  const getFieldName = useCallback((field) => {
    return typeof index === 'number' ? `personDTO.${index}.${field}` : field
  }, [])

  // const _personDTOId = useWatch({ name: getFieldName('_personDTOId') });
  const role = useWatch({ name: getFieldName('role') });
  const saveCrewFlag = useWatch({ name: getFieldName('saveCrewFlag') });
  const citizenShip = useWatch({ name: getFieldName('citizenShip') });
  const fastCard = useWatch({ name: getFieldName('fastCard') });
  const personDocumentDTO = useWatch({ name: getFieldName('personDocumentDTO') });
  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()
  
  const columns = [
    {
      title: `${aciHighwayManifestTranslationText.crewId} & ${aciHighwayManifestTranslationText.fastCard}`,
      render: (data) => {
        const { crewId, customProximityId } = data

        return (
          <Box>
            <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
              {crewId}
            </Typography>
            {customProximityId && (
              <Typography color='textSecondary' style={{ fontSize: 12, lineHeight: 1.2 }}>
                {customProximityId}
                <TinyChip label='FAST Card' variant='outlined' />
              </Typography>
            )}
          </Box>
        )
      }
    },
    {
      field: 'crewType',
      title: aciHighwayManifestTranslationText.role
    },
    {
      field: 'firstName',
      title: aciHighwayManifestTranslationText.firstName
    },
    {
      field: 'middleName',
      title: aciHighwayManifestTranslationText.middleName
    },
    {
      field: 'lastName',
      title: aciHighwayManifestTranslationText.lastName
    },
    {
      field: 'state',
      title: aciHighwayManifestTranslationText.state
    },
  ]

  function handleApplyTemplate(template) {
    if (template) {
      const {
        crewType,
        customProximityId,
        firstName,
        middleName,
        lastName,
        nationality,
        dob,
        email,
        telNo,
        internationalDoc
      } = template

      setValue(getFieldName('fastCard'), customProximityId ? true : false, { shouldDirty: true })
      setValue(getFieldName('role'), AciAceCrewTypeMapping('ACI', crewType) || '', { shouldDirty: true })
      setValue(getFieldName('fastCardNum'), customProximityId || '', { shouldDirty: true })
      setValue(getFieldName('firstName'), firstName || '', { shouldDirty: true })
      setValue(getFieldName('middleName'), middleName || '', { shouldDirty: true })
      setValue(getFieldName('lastName'), lastName || '', { shouldDirty: true })
      setValue(getFieldName('citizenShip'), nationality || '', { shouldDirty: true })
      setValue(getFieldName('dateOfBirth'), moment(dob).tz("Canada/Eastern").format('YYYY-MM-DD') || '', { shouldDirty: true })
      setValue(getFieldName('personEmail'), email || '', { shouldDirty: true })
      setValue(getFieldName('cellNum'), telNo || '', { shouldDirty: true })

      if(customProximityId.trim().length === 0 && internationalDoc){
        const processedDocs = internationalDoc.map((doc, index) => ({
          ...doc,
          _id: index + 1,
          id: null, 
          updatedBy: null, 
          updatedDate: null, 
          createdBy: null, 
          createdDate: null, 
          oriCreatedBy: null, 
          oriUpdatedBy: null, 
          oriSubmittedBy: null,
          version: null,
          documentType: doc.docType ? doc.docType === 'AIG' ? 'ACW' : doc.docType : null,
          issuingCountry: doc.country,
          documentNumber: doc.docNo,
          expiryDate: doc.expiryDate ? moment(doc.expiryDate).format('YYYY-MM-DD') : ""
        }));
    
        setValue(getFieldName('personDocumentDTO'), processedDocs, { shouldDirty: true });
      } else {
        setValue(getFieldName('personDocumentDTO'), [], { shouldDirty: true });
      }
      trigger()
    } else {
      reset()
    }
  }

  const memoedPersonDocumentSection = useMemo(() => (
    <PersonDocumentSection
      showNotification={showNotification}
      personDocumentDTO={personDocumentDTO}
      title={aciHighwayManifestTranslationText.personDocumentDTO}
      _personDTOId={_personDTOId}
      personIndex={index}
      getFieldName={getFieldName}
    />
  ), [personDocumentDTO])

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <CngGridItem xs={12} lg={4} shouldHide={shouldHideMap?.fastCard}>
              <Switch
                fullWidth
                name={getFieldName("fastCard")}
                label={aciHighwayManifestTranslationText.fastCard}
                disabled={disabled}
                onChange={(event) => {
                  setValue(getFieldName("fastCard"), event.target.checked, { shouldDirty: true })

                  if (event.target.checked) {
                    setValue(getFieldName("citizenShip"), '')
                    setValue(getFieldName("dateOfBirth"), '')
                    setValue(getFieldName("personDocumentDTO"), [])
                  } else {
                    setValue(getFieldName("fastCardNum"), '')
                  }
                }}
              />
            </CngGridItem>
            <CngGridItem xs={12} lg={8}>
              <Grid container spacing={1}>
                <CngGridItem xs={12} sm={4} shouldHide={shouldHideMap?.saveCrewFlag}>
                  <CngCheckboxField
                    name={getFieldName("saveCrewFlag")}
                    label={
                      <Typography variant='body2' style={{ fontSize: 12, lineHeight: 1.2 }}>
                        {aciHighwayManifestTranslationText.saveCrewFlag}
                      </Typography>
                    }
                    onChange={(e) => setValue(getFieldName("templateFlag"), e.target.checked, { shouldValidate: true })}
                    size='small'
                    style={{ marginLeft: 8, marginRight: 8, padding: 8 }}
                  />
                </CngGridItem>
                <CngGridItem xs={12} sm shouldHide={shouldHideMap?.crewId}>
                  <CngTextField
                    name={getFieldName("crewId")}
                    label={aciHighwayManifestTranslationText.crewId}
                    disabled={disabled || !saveCrewFlag}
                    inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                    onBlur={(e) => setValue(getFieldName("crewId"), e.target.value.toUpperCase(), { shouldValidate: true })}
                    size='small'
                  />
                </CngGridItem>
                <CngGridItem xs={12} sm={4}>
                  <NaCrewMasterAutoCompleteField
                    name={getFieldName("fetchCrew")}
                    label={aciHighwayManifestTranslationText.fetchCrew}
                    disabled={disabled}
                    onChange={(_, options) => handleApplyTemplate(options.data)}
                    lookupProps={{
                      filters: [
                        {
                          field: 'partyId',
                          operator: EQUAL,
                          value: FileForUserGetPartyId()
                        }]
                    }}
                    size='small'
                    fullWidth
                    disableClearable
                    textFieldProps={{
                      InputProps: {
                        customEndAdornment: () => (
                          <InputAdornment position='end' style={{ marginTop: -16 }}>
                            <IconButton onClick={(event) => {
                              event.stopPropagation()
                              setTemplateDialog(true)
                            }}>
                              <Box display='flex' alignItems='center' justifyContent='center' width={16} height={16}>
                                <FontAwesomeIcon icon={['fal', 'money-check-edit']} size='xs' />
                              </Box>
                            </IconButton>
                          </InputAdornment>
                        )
                      }
                    }}
                    forcePopupIcon={false}
                  />
                </CngGridItem>
              </Grid>
            </CngGridItem>
            <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.role}>
              <CngCodeMasterAutocompleteField
                required
                name={getFieldName("role")}
                label={aciHighwayManifestTranslationText.role}
                disabled={disabled}
                codeType='ACI_HW_CREW_TYPE'
                key={role}
                onChange={(value) => setValue(getFieldName("role"), value, { shouldDirty: true })}
                size='small'
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.firstName}>
              <CngTextField
                required={!fastCard}
                name={getFieldName("firstName")}
                label={aciHighwayManifestTranslationText.firstName}
                disabled={disabled}
                inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 35 }}
                onBlur={(e) => setValue(getFieldName("firstName"), e.target.value.toUpperCase(), { shouldValidate: true })}
                size='small'
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.middleName}>
              <CngTextField
                name={getFieldName("middleName")}
                label={aciHighwayManifestTranslationText.middleName}
                disabled={disabled}
                inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 25 }}
                onBlur={(e) => setValue(getFieldName("middleName"), e.target.value.toUpperCase(), { shouldValidate: true })}
                size='small'
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.lastName}>
              <CngTextField
                required={!fastCard}
                name={getFieldName("lastName")}
                label={aciHighwayManifestTranslationText.lastName}
                disabled={disabled}
                inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 60 }}
                onBlur={(e) => setValue(getFieldName("lastName"), e.target.value.toUpperCase(), { shouldValidate: true })}
                size='small'
              />
            </CngGridItem>
            {fastCard ? (
              <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.fastCardNum}>
                <CngTextField
                  required
                  name={getFieldName("fastCardNum")}
                  label={aciHighwayManifestTranslationText.fastCardNum}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 80 }}
                  onBlur={(e) => setValue(getFieldName("fastCardNum"), e.target.value.toUpperCase(), { shouldValidate: true })}
                  size='small'
                />
              </CngGridItem>
            ) : (
              <>
                <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.citizenShip}>
                  <CngCountryAutocompleteField
                    required
                    name={getFieldName("citizenShip")}
                    label={aciHighwayManifestTranslationText.citizenShip}
                    disabled={disabled}
                    key={citizenShip}
                    lookupProps={{
                      label: (record) => {
                        return `${record.code};${record.descriptionEn}`
                      }
                    }}
                    size='small'
                  />
                </CngGridItem>
                <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.dateOfBirth}>
                  <CngDateField
                    required
                    name={getFieldName("dateOfBirth")}
                    label={aciHighwayManifestTranslationText.dateOfBirth}
                    disabled={disabled}
                    size='small'
                  />
                </CngGridItem>
              </>
            )}
            <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.cellNum}>
              <CngTextField
                name={getFieldName("cellNum")}
                label={aciHighwayManifestTranslationText.cellNum}
                disabled={disabled}
                inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 15 }}
                onBlur={(e) => setValue(getFieldName("cellNum"), e.target.value.toUpperCase(), { shouldValidate: true })}
                size='small'
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} md={3} shouldHide={shouldHideMap?.personEmail}>
              <CngTextField
                name={getFieldName("personEmail")}
                label={aciHighwayManifestTranslationText.personEmail}
                disabled={disabled}
                inputProps={{ style: { textTransform: 'uppercase' }, maxLength: 255 }}
                onBlur={(e) => setValue(getFieldName("personEmail"), e.target.value.toUpperCase(), { shouldValidate: true })}
                size='small'
              />
            </CngGridItem>
          </Grid>
        </Grid>
        {!fastCard && (
          <Grid item xs={12}>
            {memoedPersonDocumentSection}
          </Grid>
        )}
      </Grid>
      <TemplateSelectDialog
        columns={columns}
        defaultSorts={[{ field: 'crewId', direction: 'ASC' }]}
        fetch={{ url: CrewMasterApiUrls.GET }}
        fetchFilters={[
          { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() },
          { field: 'inputSource', operator: EQUAL, value: InputSource.ACI_HWY_MANIFEST }
        ]}
        onApplyTemplate={handleApplyTemplate}
        onClose={() => setTemplateDialog(false)}
        open={templateDialog}
        search={{ field: 'inputValue', operator: LIKE }}
        title={aciHighwayManifestTranslationText.crewTemplate}
      />
    </>
  )
}

const PersonDTOFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default PersonDTOFormProperties
